import editorsChoiceExample from '../assets/editors-choice-example.png';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from './ui/tooltip';

interface EditorsChoiceTooltipProps {
  children: React.ReactNode;
}

export const EditorsChoiceTooltip = ({
  children,
}: EditorsChoiceTooltipProps) => {
  return (
    <TooltipProvider delayDuration={300}>
      <Tooltip>
        <TooltipTrigger asChild>{children}</TooltipTrigger>
        <TooltipContent side="top" className="p-2 max-w-[260px]" sideOffset={8}>
          <img
            src={editorsChoiceExample}
            alt="Editor's Choice placement example"
            className="rounded-md w-[240px]"
          />
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
